<div class="flex w-full border-b-[1px]  border-gray-900 " style="">
  <ng-select (ngModelChange)="selectedCompanyChanged($event)"
             [items]="geolocationStore.companies"
             [ngModel]="selectedCompany"
             bindLabel="name"
             bindValue="id"
             class="mb-4 w-full"
             placeholder="Shard wählen">

  </ng-select>
</div>
<div class="relative flex justify-end">
    <span class="isolate inline-flex rounded-md shadow-sm">
    </span>
</div>

<div class="grid gap-x-8 mt-4 w-full h-[85%] grid-rows-2  lg:grid-cols-5 lg:grid-rows-1">
  <app-map [markerService]="geolocationStore"
           class="w-full lg:col-span-3">
  </app-map>


  @if (currentView === View.Devices) {
    <div
      class="lg:col-span-2 mt-8 lg:mt-0 h-full w-full flex  justify-content-center overflow-y-scroll rounded-lg shadow ">
      @if (geolocationStore.loadingDevices) {
        <div
          class="inline-block align-self-center h-16 w-16 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
          role="status">
        </div>
      } @else {
        <!--
          Bug #234: `w-full` (Tailwind) replaces `w-100` (Bootstrap `width:100%!important`). Both declare
          `width: 100%` and nothing else sets a width here, so the swap is exact. The width IS load-bearing:
          this panel is a FLEX ITEM of the sidebar above, so without it the list would shrink to its content
          width and stop filling the sidebar.
        -->
        <div class="w-full pl-4 pb-5 pt-2 sm:p-6">


          <div class="h-full w-full">
        <span class="inline-flex space-x-1 mt-3">
          <div (click)="currentView = View.Orders"
               class="place-self-center text-gray-600 hover:text-gray-800 cursor-pointer flex w-full justify-end">
            <svg class="bi bi-arrow-left-right h-6 w-6" height="20" viewBox="0 0 16 16"
                 width="20" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5zm14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5z"
                fill-rule="evenodd"/>
            </svg>
          </div>
          <h3 class="text-2xl font-thin leading-6 text-gray-900">Geräte</h3>
        </span>
            @if (getSidebarDevices().length === 0) {
              <div class="w-full align-self-center flex h-full">
                <div class="text-center m-auto">
                  <div>
                    <div class="text-2xl font-semibold text-gray-900">Keine Geräte verfügbar</div>
                    <div class="text-gray-500">Keine Geräte unter der aktuellen Einstellung</div>
                  </div>
                </div>
              </div>
            } @else {
              <ul class="divide-y max-h-max  divide-gray-100 h-full bg-white overflow-y-auto"
                  role="list">


                @for (device of getSidebarDevices(); track device.id; let i = $index) {
                  <li class="flex-grid grid-rows-2 grid-cols-1 w-full h-fit">
                    <div
                      [ngClass]="{'bg-gray-50': inActiveDeviceList(device), 'rounded-t-2xl': i === 0, 'rounded-b-2xl': i === (geolocationStore.sidebarDevices.length - 1)}"
                      class="row-start-1 flex  justify-between h-fit">

                      <div class="flex w-full gap-x-4 mx-3 my-auto">
                        <div class="inline-flex gap-x-2">
                          <div class="flex h-10 my-auto w-4">
                            <input (ngModelChange)="changeDisplayedDevice(device)" [id]="'cb_' + device.id"
                                   [ngModel]="inActiveDeviceList(device)"
                                   class="my-auto h-4 w-4 rounded border-gray-300 text-theme-primary-600 cursor-pointer"
                                   type="checkbox">
                          </div>
                        </div>

                        <div class="w-full flex  my-3   justify-content-between">
                          <div class="grid grid-rows-2 grid-cols-1 ">
                            <p class="text-sm font-semibold leading-6 text-gray-900">{{ device.name }}</p>
                            <p
                              class="text-sm font-thin leading-6 text-gray-900">
                              Standorte: {{ geolocationStore.markerCount(device.id) }}</p>
                          </div>
                          <div class="my-auto inline-flex ">
                            <div class="">
                              <svg [ngClass]="{'hidden': !(isFarFromCenter(device.id)==0)}" class="w-6 h-6 fill-none"
                                   stroke="red" stroke-width="1.5" viewBox="0 0 24 24"
                                   xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"/>
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div [ngClass]="{'opacity-0 pointer-events-none': device.deviceLocations.length == 0}"
                             class="my-auto select-none">
                          <svg (click)="toggleIsExpanded(device.id)"
                               [ngClass]="{'rotate-90': !isExpandedActive(device.id)}"
                               class="w-6 h-6 cursor-pointer transition-all fill-none"
                               stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"
                               xmlns="http://www.w3.org/2000/svg">
                            <path d="m19.5 8.25-7.5 7.5-7.5-7.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                      </div>
                    </div>

                    <ul [ngClass]="{'hidden': !isExpandedActive(device.id)}"
                        class="row-start-2 px-3 cursor-pointer divide-y divide-gray-100 w-full  my-0 py-0"
                        role="list">
                      @for (position of geolocationStore.getCachedBundles(device.id); track $index) {
                        <li (click)="centerMap(position.lat,position.lng)" class="flex justify-between gap-x-6 py-2 ">
                          <div class="flex justify-content-between w-full">
                            <div class="flex-grid grid-cols-1 grid-rows-2">
                              <p class="text-xs font-semibold leading-6 text-gray-900">
                                Lat.: <span class="fw-light">{{ position.lat.toFixed(8) }}</span></p>
                              <p class="row-start-2 text-xs font-semibold leading-6 text-gray-900">
                                Long.: <span class="fw-light">{{ position.lng.toFixed(8) }}</span></p>
                            </div>
                            <p class="text-xs font-semibold leading-6 text-gray-900">Anzahl: <span
                              class="fw-light">{{ position.count }}</span></p>
                          </div>
                        </li>
                      }
                    </ul>
                  </li>
                }
              </ul>
            }
          </div>
        </div>
      }
    </div>
  }

  @if (currentView === View.Orders) {
    <div
      class="lg:col-span-2 mt-8 lg:mt-0 h-full w-full flex  justify-content-center overflow-y-scroll rounded-lg shadow ">
      @if (geolocationStore.loadingOrderCounts) {
        <div
          class="inline-block align-self-center h-16 w-16 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
          role="status">
        </div>
      } @else {
        <!-- Bug #234: `w-full` (Tailwind) replaces `w-100` (Bootstrap `width:100%!important`) — same
             `width: 100%`, and load-bearing for the same reason as the devices panel above. -->
        <div class="w-full pl-4 pb-5 pt-2 sm:p-6">
          <div class="h-full w-full">
        <span class="inline-flex space-x-1 mt-3">
          <div (click)="currentView = View.Devices"
               class="place-self-center text-gray-600 hover:text-gray-800 cursor-pointer flex w-full justify-end">
            <svg class="bi bi-arrow-left-right h-6 w-6" height="20" viewBox="0 0 16 16"
                 width="20" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5zm14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5z"
                fill-rule="evenodd"/>
            </svg>
          </div>
          <h3 class="text-2xl font-thin leading-6 text-gray-900">Bestellungen</h3>
        </span>

            @if (getOrderCountFromShard(selectedCompany).length === 0) {
              <div class="w-full align-self-center flex h-full">
                <div class="text-center m-auto">
                  <div>
                    <div class="text-2xl font-semibold text-gray-900">Keine Bestellungen verfügbar</div>
                    <div class="text-gray-500">Keine Bestellungen unter der aktuellen Einstellung</div>
                  </div>
                </div>
              </div>
            } @else {
              <ul class="divide-y max-h-max divide-gray-100 h-full bg-white overflow-y-auto"
                  role="list">
                @for (orderCount of getOrderCountFromShard(selectedCompany); track $index) {
                  <li class="flex-grid grid-rows-2 grid-cols-1 w-full h-fit">
                    <div class="row-start-1 flex  justify-between h-fit">

                      <div class="flex w-full gap-x-4 mx-3  my-auto">
                        <div class="w-full flex  my-3   justify-content-between">
                          <div class="grid grid-rows-2 grid-cols-1 ">
                            <p class="text-sm font-semibold leading-6 text-gray-900">{{ orderCount.start | date :'short' }}
                              - {{ orderCount.end | date :'short' }}</p>
                            <p
                              class="text-sm font-thin leading-6 text-gray-900">Orders: {{ orderCount.count }}</p>
                          </div>
                          <div class="my-auto inline-flex ">
                            <div class="">
                              <svg [ngClass]="{'hidden': !(orderCount.count>=limit)}" class="w-6 h-6 fill-none"
                                   stroke="red" stroke-width="1.5" viewBox="0 0 24 24"
                                   xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"/>
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                }
              </ul>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
